module.exports = __webpack_public_path__ + "img/logo.d0a64b7b.png";